export function reconcileReceiptOrder(previous: string[], current: string[]) {
  const active = new Set(current);
  const retained = previous.filter(id => active.has(id));
  return [...retained, ...current.filter(id => !retained.includes(id))];
}
